"use client";

import styled from "styled-components";
import Icon from "../icon";

export const DropdownButton = styled.button`
  padding: 5px;
  border-radius: 5px;
  font-family: "Roboto Medium";
  font-size: 14px;

  &:hover {
  }
`;

export const DropdownTitle = styled.h4`
  font-family: "Roboto Medium";
  color: var(--colorTitle);
  padding: calc(0.25rem * 2);
`;

export const DropdownContent = styled.div``;

export const DropdownItem = styled.div`
  padding: calc(0.25rem * 1.5) calc(0.25rem * 2);
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--colorText);
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background: var(--hoverDropdownItem);
    color: var(--textHover);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  border: 1px solid #ccc;
  z-index: 1;
  display: none;
  visibility: hidden;
  opacity: 0;
  transition: 0.2s ease-in-out;
  background: var(--backgroundColor);
  border: 1px solid var(--border);
  border-radius: 5px;
  padding: calc(0.25rem * 1);
  min-width: 8rem;
`;

export const DropdownBox = styled.div`
  position: relative;
  width: fit-content;

  &:hover {
    ${Dropdown} {
      display: block;
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const IconComponent = styled(Icon)`
  svg {
    max-width: 20px !important;
    max-height: 20px !important;

    path {
      fill: var(--titleColor);
    }
  }
`;
